import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../constants/mediaQueries";

export const RequestAddContainerStyle = createUseStyles((theme: any) => ({
    container: {
        height: "100%",
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        gap: 15,
        backgroundColor: "#ffffff",
    },

    form: {
        padding: "15px",
        width: "100%",
        gap: 10,
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
    },
    icon: {
        maxWidth: "4rem",
    },
    row: {
        display: "flex",
        gap: 15,
        width: "95vw",
        maxWidth: 500,
    },
    flag: {
        cursor: "pointer",
    },
}));
